import type { Node } from "@xyflow/react";

export function buildStepPositionUpdates(
  nodes: Node[],
  draggedNodes: Node[],
  pendingPositions?: Map<string, { x: number; y: number }>
): Array<{ id: string; uiPosition: { x: number; y: number } }> {
  const draggedById = new Map(draggedNodes.map((node) => [node.id, node]));

  return nodes
    .filter((node) => node.type === "stepNode")
    .map((node) => {
      const current = draggedById.get(node.id) ?? node;
      const pendingPosition = pendingPositions?.get(node.id);
      return {
        id: node.id,
        uiPosition: pendingPosition ?? { x: current.position.x, y: current.position.y },
      };
    });
}
